import React from "react";
import styled from "styled-components";


const Wrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  min-height: 100vh;

  @media (min-width: 768px) {
    padding: 5rem 4rem;
  }
`;

const Content = styled.div`
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #0077cc;
  margin-bottom: 1.5rem;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  color: #444;
  margin-bottom: 1.2rem;
`;

const InfoBox = styled.div`
  background-color: #eef6ff;
  padding: 1.5rem;
  margin: 2rem 0;
  color: #003d73;
  border-radius: 8px;
  font-weight: 500;
`;

const CTA = styled.a`
  background-color: #0077cc;
  color: white;
  padding: 0.9rem 1.6rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 6px;
  text-decoration: none;

  &:hover {
    background-color: #005fa3;
  }
`;

const Final = styled.p`
  margin-top: 3rem;
  font-size: 1rem;
  color: #555;
  font-style: italic;
`;

const ContatoVendaPersonalizada = () => {
  const search = new URLSearchParams(window.location.search);
  const cotas = search.get("cotas") || "mais de 6";

  return (
    <Wrapper>
      <Content>
        <Title>📞 Solicitação para venda de {cotas} cotas</Title>

        <Paragraph>
          Que ótimo saber que você quer anunciar {cotas} cotas!
        </Paragraph>

        <Paragraph>
          Para casos acima de 6 cotas, oferecemos um atendimento personalizado com planos sob medida e condições especiais.
        </Paragraph>

        <InfoBox>
          Clique no botão abaixo para falar diretamente com nosso time e receber sua proposta exclusiva.
        </InfoBox>

        <CTA href="https://wa.me/message/H7PTB2XYZUDAO1" target="_blank">
          📲 Falar com o atendimento
        </CTA>

        <Final>
          Agradecemos pela confiança. Vamos fazer o seu anúncio render resultados reais!
        </Final>
      </Content>
    </Wrapper>
  );
};

export default ContatoVendaPersonalizada;
